var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c("el-header", [
        _c(
          "div",
          {
            staticClass: "logo",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.backToHome($event)
              }
            }
          },
          [
            _c("span", { staticClass: "czc" }, [
              _vm._v("厂中厂安全隐患排查系统")
            ])
          ]
        ),
        _c(
          "div",
          { staticClass: "menu_content" },
          [
            _c(
              "el-menu",
              {
                attrs: {
                  "default-active": _vm.activeMenu,
                  "background-color": _vm.variables.menuOnLevelBg,
                  "text-color": _vm.variables.menuOnLeveltext,
                  "unique-opened": true,
                  "collapse-transition": false,
                  mode: "horizontal",
                  router: ""
                }
              },
              _vm._l(_vm.permission_routes, function(route) {
                return _c(
                  "el-menu-item",
                  { key: route.path, attrs: { index: route.path } },
                  [
                    _c("div", { staticClass: "icon" }),
                    _vm._v(" " + _vm._s(route.meta && route.meta.title) + " ")
                  ]
                )
              }),
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "right-menu flex flex-row flex_align_item_center" },
          [
            _vm.superAdminFlag === 1
              ? _c("svg-icon", {
                  staticClass: "super",
                  attrs: { "icon-class": "super" }
                })
              : _vm._e(),
            _c("span", { staticClass: "accountName" }, [
              _vm._v(_vm._s(_vm.loginAccount))
            ]),
            _c("svg-icon", {
              staticClass: "exit",
              attrs: { "icon-class": "a-signout" },
              on: { click: _vm.logout }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }